/** @module EngineeringChange/AddToAffectedSpecsController */
define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"./_AggregateSpecsMixin"
], function(declare,Controller,_AggregateSpecsMixin) {
	return declare([Controller,_AggregateSpecsMixin], {
	});
});